const addCommas = (num: string | number | null | undefined): string => {
    if (num === null || num === undefined || num === '') return '0.00';
    if (num === 0 || num === "0") return "0.00";
    
    const strNum = num.toString();
    const isNegative = strNum.startsWith('-');
    let z = strNum
        .replace(/[^0-9.]/gi, "")
        .replace(/^0+/, "")
        .replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, "$&,");
    
    if (z.indexOf(".") === 0) z = "0" + z;
    
    if (z.includes(".")) {
        const parts = z.split(".");
        z = parts[0] + "." + (parts[1] + "00").substring(0, 2);
    } else {
        z += ".00";
    }
    
    return isNegative ? "-" + z : z;
};

export default addCommas;